module.exports = __webpack_public_path__ + "img/bannerCustomer2.f8e067e2.png";